import addDashboardCard from './addDashboardCard'
import updateDashboardCard from './updateDashboardCard'
import changeDashboardName from './changeDashboardName'
import copyDashboard from './copyDashboard'
import copyDashboardCard from './copyDashboardCard'
import createDashboard from './createDashboard'
import deleteDashboard from './deleteDashboard'
import deleteDashboardCard from './deleteDashboardCard'
import reorderUserDashboards from './reorderUserDashboards'
import { type MutationResolvers } from '../../../../generated/graphql'

export const dashboardsMutations: MutationResolvers = {
    addDashboardCard,
    updateDashboardCard,
    changeDashboardName,
    copyDashboard,
    copyDashboardCard,
    createDashboard,
    deleteDashboard,
    deleteDashboardCard,
    reorderUserDashboards,
}

export default dashboardsMutations
